import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=fad59e76&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&id=fad59e76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad59e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fad59e76')) {
      api.createRecord('fad59e76', component.options)
    } else {
      api.reload('fad59e76', component.options)
    }
    module.hot.accept("./trade.vue?vue&type=template&id=fad59e76&scoped=true&", function () {
      api.rerender('fad59e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bussiness/report-amount-jx/trade.vue"
export default component.exports